module.exports = __webpack_public_path__ + "img/mgj.4c3c71a1.png";